<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header align-items-start">
      <div class="flex-fill pdgr">
        <h1 class="h4 mrgv0">
          {{ $t('directories.directory.delete.title') }}
        </h1>
        <h2 v-if="directory && directory.name" class="h5 text-alt mrgt-- mrgb0">
          {{ directory.name }}
        </h2>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <main class="dialog-body">
      {{ $t('directories.directory.delete.message') }}
    </main>

    <div class="dialog-footer">
      <ListInline align="center" size="small">
        <li>
          <Btn variant="outline" @click="isOpen = false">
            {{ $t('common.cancel') }}
          </Btn>
        </li>
        <li>
          <Btn variant="danger" @click="doDeleteDirectory">
            <div class="flex">
              <Loader v-if="loading" size="small" negative />
              <template v-else>
                {{ $t('common.delete') }}
              </template>
            </div>
          </Btn>
        </li>
      </ListInline>
    </div>
  </CDialog>
</template>

<script>
import eventBus from '@/eventBus';

import Loader from '@/components/ui/Loader';
import { mapActions } from 'vuex';

export default {
  components: {
    Loader,
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      directory: null,
    };
  },

  watch: {
    isOpen(isOpen) {
      if (!this.isOpen) {
        this.directory = null;
      }
    },
  },

  mounted() {
    eventBus.$on('toggleDirectoryDelete', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('toggleDirectoryDelete', this.handleToggle);
  },

  methods: {
    ...mapActions('directories', ['deleteDirectory']),
    handleToggle(directory) {
      this.directory = directory;
      this.isOpen = !this.isOpen;
    },
    doDeleteDirectory() {
      this.loading = true;
      this.deleteDirectory({
        directory: this.directory,
      })
        .then(() => {
          this.isOpen = false;
          this.$router.push(`/directories`);
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
